import React from "react";
import { Link, useNavigate } from "react-router-dom";

export default function BreadcrumTop({title}){
    const navigate = useNavigate();
    
    return (
        <div className="row page-titles mx-0 pl-10 pr-10 py-3 mt-xs-20">
            <div className="col-6 p-md-0">
                <div className="welcome-text">
                    <h4>{title}</h4>
                </div>
            </div>
            <div className="col-6 p-md-0 justify-content-sm-end mt-2 mt-sm-0 d-flex">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a href="#">Dashboard</a></li>
                    <li className="breadcrumb-item active"><a href="#">{title}</a></li>
                </ol>
            </div>
        </div>
    );
}